import React from 'react'
import { connect } from 'react-redux'
import ConfirmableCheckboxView from '../component/ConfirmableCheckboxView'
import { Checkbox } from '../../Form/Checkbox'
import { showReduxModal } from '../../../Reducers/UI/actions'

const ConfirmableCheckbox = ({
  label,
  note,
  noteStyles = {},
  value,
  confirmationModal,
  showReduxModal,
  disabled,
  cypress_id,
  labelColor = null,
}) => {
  const onChange = () => {
    if (disabled) return
    if (!confirmationModal.showOnDisable && value) {
      return confirmationModal.onConfirm(!value)
    }
    return showReduxModal({
      ...confirmationModal,
      onConfirm: () => confirmationModal.onConfirm(!value),
      children: confirmationModal.body,
    })
  }

  return (
    <ConfirmableCheckboxView note={note} noteStyles={noteStyles}>
      <Checkbox
        label={label}
        shouldListenToInputValue
        input={{
          value,
          onChange,
          disabled,
        }}
        cypress_id={cypress_id}
        labelColor={labelColor}
      />
    </ConfirmableCheckboxView>
  )
}

const mapDispatchToProps = {
  showReduxModal,
}

export default connect(
  null,
  mapDispatchToProps,
)(ConfirmableCheckbox)
